import React, { useEffect, useState } from 'react';

interface Star {
  id: number;
  left: string;
  top: string;
  delay: number;
  layer: number;
}

// Étoiles précalculées pour chaque couche
const PRECALCULATED_STARS: Star[] = [
  ...Array.from({ length: 30 }, (_, i) => ({
    id: i + 1000,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    delay: Math.random() * 5, // Réduit à 5 secondes max
    layer: 1
  })),
  ...Array.from({ length: 40 }, (_, i) => ({
    id: i + 2000,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    delay: Math.random() * 5,
    layer: 2
  })),
  ...Array.from({ length: 60 }, (_, i) => ({
    id: i + 3000,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    delay: Math.random() * 5,
    layer: 3
  }))
];

const StarrySky: React.FC = () => {
  const [twinklingStars, setTwinklingStars] = useState<number[]>([]);

  // Uniquement l'effet de scintillement
  useEffect(() => {
    const twinkleInterval = setInterval(() => {
      const numberOfTwinklingStars = Math.floor(Math.random() * 5) + 3;
      const newTwinklingStars = Array.from({ length: numberOfTwinklingStars }, () =>
        Math.floor(Math.random() * PRECALCULATED_STARS.length)
      );
      setTwinklingStars(newTwinklingStars);
    }, 2000);

    return () => clearInterval(twinkleInterval);
  }, []);

  return (
    <div className="starry-sky">
      {PRECALCULATED_STARS.map((star) => (
        <div
          key={star.id}
          className={`star star-layer-${star.layer} ${twinklingStars.includes(star.id) ? 'twinkle' : ''}`}
          style={{
            left: star.left,
            top: star.top,
            animationDelay: `${star.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default StarrySky;
